export default __webpack_public_path__ + "static/media/Girdle of Erlik.04aefb2e.jpg";